export default ($auth) => {
  return new Promise((resolve, reject) => {
    $auth.parseHash((error, response) => {
      if (error) {
        reject(error)
        throw new Error(error)
      }

      const { accessToken } = response

      return resolve(accessToken)
    })
  })
}
